import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Juan', 'María', 'Lucas', 'Sofía', 'Martín', 'Camila', 'Diego', 'Valentina', 'Facundo', 'Julieta'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Neuquén', 'Salta', 'Tucumán', 'Santa Fe'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: `${randomTime} min`
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000); // hide after 5s
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Then repeat every 20-30s
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-white rounded-xl shadow-2xl border border-sage/30 p-4 pr-12 z-50 animate-fade-up max-w-sm" data-id="element-120">
      <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-ink/40 hover:text-ink" data-id="element-121">
        <X className="w-4 h-4" data-id="element-122" />
      </button>
      <div className="flex items-start gap-3" data-id="element-123">
        <div className="mt-1" data-id="element-124">
          <CheckCircle2 className="w-6 h-6 text-forest" data-id="element-125" />
        </div>
        <div data-id="element-126">
          <p className="text-sm text-ink/80" data-id="element-127">
            <span className="font-bold text-ink" data-id="element-128">{data.name}</span> de{' '}
            {data.city}
          </p>
          <p className="text-xs font-medium text-forest mt-1" data-id="element-129">
            Compró Mindfulness para Runners
          </p>
          <p className="text-xs text-ink/40 mt-1" data-id="element-130">Hace {data.time}</p>
        </div>
      </div>
    </div>;
}